<template>
  <!-- comment-item -->
  <section>
    <transition name="fade">
      <div class="modal-mask" v-if="isShowLikes">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="flex-box parent-comment modal-flex">
              <slot name="header">
                  <!-- <button @click="onClickDelete" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button> -->
                  <span class="info-userimg">
                    <router-link :to="{ name: 'User', params: { userId: targetItem.userId }}">
                      <img v-if="getUserInfoById(targetItem.userId).userIcon" :src="getUserInfoById(targetItem.userId).userIcon" alt="image" class="img-circle">
                      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                    </router-link>
                  </span>
                  <div class="comment detail-head">
                    <div class="info-userelement">
                      <span class="info-username">{{ getUserInfoById(targetItem.userId).userName }}</span>
                      <span class="info-time" v-if="targetItem.itemType === '1on1'">
                        {{reviewOf(targetItem.createdAt)}}
                      </span>
                      <span class="info-time" v-else>
                        {{targetItem.createdAt | preparedTime}}
                      </span>
                    </div>
                    <!-- {{targetItem.id}} -->
                    <div class="flex-box fl-between">
                      <span v-if="targetItem.isStamp" class="show-stamp">
                        <img :src="getStampImg(targetItem.isStamp)" :alt="targetItem.isStamp">
                      </span>
                      <span v-else class="comment-text">
                        <read-more :targetId="targetItem.id" :isGrayOut="!!targetItem.isDelete" :text="getContentText" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
                          {{ getContentText }}
                        </read-more>
                      </span>
                    </div>
                  </div>
              </slot>
            </div>

            <div class="likes-modal-body">
              <slot name="body">
                <div v-for="(value, userId) in targetItem.likes" :key="userId" class="likes-ibox-child">
                  <template v-if="getUserInfoById(userId).isDeleted">
                    <span class="search-userimg">
                      <img v-if="getUserInfoById(userId).userIcon" :src="getUserInfoById(userId).userIcon" alt="image" class="img-circle">
                      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                    </span>
                    <div class="search-userinfo">
                      <span class="search-username">{{ getUserInfoById(userId).userName }}</span>
                      <span class="search-userdept">{{ getUserInfoById(userId).dept }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <router-link :to="{ name: 'User', params: { userId: userId }}" class="d-flex align-items-center"  v-if="getUserInfoById(userId)">
                      <span class="search-userimg">
                        <img v-if="getUserInfoById(userId).userIcon" :src="getUserInfoById(userId).userIcon" alt="image" class="img-circle">
                        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                      </span>
                      <div class="search-userinfo">
                        <span class="search-username">{{ getUserInfoById(userId).userName }}</span>
                        <span class="search-userdept">{{ getUserInfoById(userId).dept }}</span>
                      </div>
                    </router-link>
                  </template>
                </div>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <div class="row okr-regist-btnset">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-sm-offset-3"><button @click="closeModal" type="button" class="btn btn-danger block m-b">{{ $t('indicateItemClose') }}</button></div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
  <!-- /comment-item -->
</template>

<script>
import { mapGetters } from 'vuex'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
import { stampsurl } from '@/main'
Vue.use(Viewer)

export default {
  name: 'ModalLikes',
  props: {
    targetItem: {
      id: String, // アイテムのID
      contentText: String,
      createdAt: String,
      userId: String, // アイテム製作者のユーザID
      likes: {
        type: Object,
        default: {}
      },
      itemType: {
        type: String,
        default: 'rtfb'
      }
    }
  },
  components: {
    ReadMore
  },
  data () {
    return {
      propShowMore: false,
      propContentHeight: 0,
      isShowLikes: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getContentText () {
      if (!this.targetItem.isDelete) {
        return this.targetItem.contentText
      } else {
        return this.$t('deletedComentStr')
      }
    },
    getLikes () {
      return Object.keys(this.targetItem.likes).map(x => !!this.getUserInfoById(x))
    }
  },
  methods: {
    showModal () {
      this.isShowLikes = true
    },
    reviewOf: function (date) {
      let ymd = (date || '').split('/')
      let dateFormatted = this.$t('noticeDateFormat')
        .replace('{$y}', (ymd[0] || '----'))
        .replace('{$m}', (ymd[1] || '--'))
        .replace('{$d}', (ymd[2] || '--'))
      return this.$t('retrospectiveStr').replace('{$date}', dateFormatted)
    },
    closeModal () {
      this.isShowLikes = false
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      // console.log('in comment updateContentHeight::', value)
      this.propContentHeight = value
    },
    getStampImg (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    momentDay: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentTime: function (date) {
      return moment(date).format('HH:mm:ss')
    }
  }
}
</script>
<style scoped>
.parent-comment {
  padding-bottom: 10px;
}
.modal-enter-active, .modal-leave-active {
  transition: all .2s ease ;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
}
.modal-flex {
  margin: 5px 5px 0px 5px;
}
.likes-ibox-child{
  position: relative;
  background-color: #ffffff;
  color: inherit;
  padding: 1.2rem 1.3rem;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/ModalLikes.vue